// src/layout/menuItems.js
import { Home, History, LogOut, Upload } from "lucide-react";

export const getMenuItems = (navigate, handleLogout) => [
  {
    key: "home",
    icon: <Home className="w-5 h-5" />,
    label: "Dashboard",
    onClick: () => navigate("/dashboard"),
  },
  {
    key: "data-entry",
    icon: <Upload className="w-5 h-5" />,
    label: "Data Upload",
    onClick: () => navigate("/dashboard/data-entry"),
  },
  {
    key: "upload",
    icon: <History className="w-5 h-5" />,
    label: "Data History",
    onClick: () => navigate("/dashboard/upload-result"),
  },
  {
    key: "logout",
    icon: <LogOut className="w-5 h-5" />,
    label: "Logout",
    onClick: handleLogout,
  },
];